export default "__VITE_ASSET__VkbfH26D__"